/** True when `content` is a lone image/GIF URL (Giphy, legacy Tenor CDN, or .gif). */
export function isSupportChatMediaUrl(content) {
    const trimmed = content.trim();
    if (!trimmed || /\s/.test(trimmed))
        return false;
    try {
        const url = new URL(trimmed);
        if (!/^https?:$/i.test(url.protocol))
            return false;
        if (/\.gif(\?|$)/i.test(url.pathname))
            return true;
        return /giphy\.com|tenor\.com|media\.tenor\.com/i.test(url.hostname);
    }
    catch {
        return false;
    }
}
